import React, { Component } from 'react'
import './stickelement.scss'

import Button from '../Button'
import Tags from '../Tags'

class StickElement extends Component {
	constructor(props) {
		super(props)
		this.state = {
			info: props.info ? props.info : []
		}
	}

	render() {
		let classes = ['vbui--stickelement', this.props.classes].join(' ')
		return (
			<div className={classes}>
				{this.props.tagMsg && <Tags classes={this.props.first && 'black'}>{this.props.tagMsg}</Tags>}
				{this.props.lastElement && (
					<Button
						classes="small ghost remove-btn"
						showIcon="true"
						icon="icon-icon-delete"
						onClick={this.props.click}
					></Button>
				)}
				<div className="img-carrier">
					<img src={this.props.imgURL} alt="" />
				</div>
				<p className="element-title">{this.props.title}</p>
				<p className="element-subtitle">{this.props.subtitle}</p>
			</div>
		)
	}
}

export default StickElement
